import type { AnyToolCall } from "@containers/Hermes/types";

type ToolCallPillProps = {
  toolCall: AnyToolCall;
  isStreaming?: boolean;
};

export default function ToolCallPill({ toolCall, isStreaming = false }: ToolCallPillProps) {
  const label = toolCall.label ?? toolCall.tool ?? toolCall.tool_name ?? "";
  const summary = toolCall.summary ?? "";
  const text = summary || label;

  const isInFlight = isStreaming && toolCall.error === undefined;
  const isFailure = typeof toolCall.error === "string" && toolCall.error !== "";

  return (
    <div className="tw-flex tw-items-center tw-gap-2 tw-bg-gray-50 tw-border tw-border-gray-100 tw-rounded-lg tw-px-3 tw-py-2 tw-w-full">
      {isInFlight ? (
        <span className="tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-w-5 tw-h-5 tw-rounded-full tw-bg-primary-purple-50">
          <span className="material-symbols-outlined tw-text-[14px] tw-text-primary-purple-500 tw-animate-pulse" aria-hidden="true">
            wand_shine
          </span>
        </span>
      ) : isFailure ? (
        <span className="tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-w-5 tw-h-5 tw-rounded-full tw-bg-error-100" title={toolCall.error ?? undefined}>
          <span className="material-symbols-outlined tw-text-[14px] tw-text-error-500" aria-hidden="true">
            close
          </span>
        </span>
      ) : (
        <span className="tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-w-5 tw-h-5 tw-rounded-full tw-bg-success-100">
          <span className="material-symbols-outlined tw-text-[14px] tw-text-success-600" aria-hidden="true">
            check
          </span>
        </span>
      )}

      <span className="tw-text-sm tw-text-gray-400 tw-truncate">{text}</span>
    </div>
  );
}
